<div class="team-form-main-container">
  <ng-scrollbar [autoHeightDisabled]="false" [autoWidthDisabled]="false">
    <div scrollViewport>
      <form [formGroup]="teamForm" class="form-content">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
          <mat-label>Team Name</mat-label>
          <input matInput forbidAngleBrackets type="text" formControlName="name" />
          <mat-error *ngIf="teamForm.get('name').hasError('unique')">
            {{ teamForm.get('name').getError('unique') }}
          </mat-error>
          <mat-error *ngIf="teamForm.get('name').hasError('notEmpty')">
            {{ teamForm.get('name').getError('notEmpty') }}
          </mat-error>
          <mat-error *ngIf="teamForm.get('name').hasError('minlength')">
            Team name must be at least 4 characters
          </mat-error>
          <mat-error *ngIf="teamForm.get('name').hasError('maxlength')">
            Team name can be at most 255 characters
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
          <mat-label>Public Name</mat-label>
          <input matInput forbidAngleBrackets type="text" formControlName="publicName" id="public-team-name-input" />
          <mat-error *ngIf="teamForm.get('publicName').hasError('minlength')">
            Team name must be at least 4 characters
          </mat-error>
          <mat-error *ngIf="teamForm.get('publicName').hasError('maxlength')">
            Team name can be at most 255 characters
          </mat-error>
        </mat-form-field>
        <div *ngIf="cloneMode" class="clone-container">
          <mat-checkbox formControlName="copyPeople" color="primary">Copy people to the new team</mat-checkbox>
        </div>
        <div fxLayoutAlign="space-between" formGroupName="dateGroup">
          <mat-form-field appearance="outline" floatLabel="always" fxFlex="47%">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="startDate" [errorStateMatcher]="matcher" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            <mat-error *ngIf="dateFormGroup.hasError('startDateBeforeEndDate')">
              Start date must be before the end date
            </mat-error>
            <mat-error *ngIf="dateFormGroup.hasError('requiredStartDate')">
              Start date is required if an end date is set
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" fxFlex="47%">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate" />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div *ngIf="cloneMode">
          <mat-divider *ngIf="attributesEditorDataSource.hasAttributes"></mat-divider>
          <attributes-editor
            #attributesEditor
            [dataSource]="attributesEditorDataSource"
            [onTeamForm]="true"
            fxFlexWidth="100%"
          >
          </attributes-editor>
        </div>
      </form>
    </div>
  </ng-scrollbar>
</div>
